import { Component, computed, input, signal } from "@angular/core";
import { AuthService } from "@auth0/auth0-angular";
import { environment } from "src/environments/environment";
import { EVServiceType } from "src/util/auth0/models/evServiceType.enum";
import { Subscription } from "rxjs";
import { EvMultiSearchComponent } from "../../../shared-components/ev-multi-search/ev-multi-search.component";
import { EvPageTopMenuComponent } from "src/app/shared-components/ev-page-top-menu/ev-page-top-menu.component";
import { SearchGuideComponent } from "../../../shared-components/ev-multi-search/search-guide/search-guide.component";
import { SearchMode } from "src/services/search-state.service";

@Component({
    selector: "infopage-header",
    imports: [EvPageTopMenuComponent, EvMultiSearchComponent, SearchGuideComponent],
    templateUrl: "./infopage-header.component.html",
    styleUrls: ["./infopage-header.component.scss"],
})
export class InfopageHeaderComponent {
    title = input<string>("");
    evServiceType = EVServiceType;

    subscription: Subscription;

    // Search integration (ported from search-bar component)
    openAsExpanded = input<boolean>(false);
    SearchModeEnum = SearchMode;
    searchMode: SearchMode = SearchMode.MULTISEARCH;
    expand = computed(() => this.openAsExpanded() || this.localExpandState());
    protected localExpandState = signal<boolean>(false);
    constructor(public auth: AuthService) {}

    ngOnDestroy(): void {
        //this.subscription.unsubscribe();
    }

    returnToEvWeb() {
        const returnTo = sessionStorage.getItem("returnTo") as string;
        window.location.href = returnTo;
    }

    logOut(): void {
        this.auth.logout({ logoutParams: { returnTo: environment.logoutUrl } });
    }

    openSearch() {
        this.localExpandState.set(true);
    }

    searchChange(mode: SearchMode) {
        this.searchMode = mode;
    }
}
